import { Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import Header from "./component/Header.jsx";
import Footer from "./component/Footer.jsx";
import "./styles/global.css";
import "./App.css";

const Home = lazy(() => import("./page/Home.jsx"));
const WhoWeAre = lazy(() => import("./page/WhoWeAre.jsx"));
const Insights = lazy(() => import("./page/Insights.jsx"));
const Careers = lazy(() => import("./page/Careers.jsx"));
const ContactUs = lazy(() => import("./page/ContactUs.jsx"));
const WhatWeDo = lazy(() => import("./page/WhatWeDo.jsx"));

function App() {

  useEffect(() => {
  // MOBILE ONLY
     const isMobile = window.matchMedia("(pointer: coarse)").matches;
    if (!isMobile) return;

    const cards = document.querySelectorAll(".glow-card");

    const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        } else {
          entry.target.classList.remove("active");
        }
      });
      },
     {
      threshold: 0.6, // center focus
     }
   );

   cards.forEach(card => observer.observe(card));

    return () => observer.disconnect();
    }, []);


  return (
    <div className="App">
      {/* Desktop-only cursor */}
      <div className="cyber-cursor"></div>

      <Header />

      <Suspense fallback={<div className="loading"></div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </Suspense>

      <Footer />
    </div>
  );
}

export default App;
